import React from "react";

const AppML_API = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML API</h1>
      <p>This is the AppML API page content.</p>
    </div>
  );
};

export default AppML_API;
